<template>
<div class="MStepThree">
    <div class="content_warp">
        <div v-if="typeValue === 'A01'" class="type_box">
            <div class="row_box">
                <p class="title_text">所处行业</p>
                <van-cell :title="formType.industryname === '' ? '请选择' : formType.industryname" is-link @click="selectIndustry"/>
            </div>
            <div class="row_box">
                <p class="title_text">市盈率</p>
                <van-field v-model="formType.pevalue" type="number" placeholder="根据行业自动获取" />
            </div>
            <div class="row_box">
                <p class="title_text">净利润</p>
                <van-field v-model="formType.netprice" maxlength="10" placeholder="请输入"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">验证码</p>
                <van-field v-model="usercode" maxlength="4" placeholder="请输入验证码"><template #button><img @click="getAuthCode" class="auth_code_img" :src="authCodeImg === '' ? require('@/common/images/gujingimgs/bg1.png') : authCodeImg" alt=""></template></van-field>
            </div>
        </div>
        <div v-if="typeValue === 'A02'" class="type_box">
            <div class="row_box">
                <p class="title_text">所处行业</p>
                <van-cell :title="formType.industryname === '' ? '请选择' : formType.industryname" is-link @click="selectIndustry"/>
            </div>
            <div class="row_box">
                <p class="title_text">市净率</p>
                <van-field v-model="formType.pbvvalue" type="number" placeholder="根据行业自动获取" />
            </div>
            <div class="row_box">
                <p class="title_text">净资产</p>
                <van-field v-model="formType.netprice" maxlength="10" placeholder="请输入"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">验证码</p>
                <van-field v-model="usercode" maxlength="4" placeholder="请输入验证码"><template #button><img @click="getAuthCode" class="auth_code_img" :src="authCodeImg === '' ? require('@/common/images/gujingimgs/bg1.png') : authCodeImg" alt=""></template></van-field>
            </div>
        </div>
        <div v-if="typeValue === 'A03'" class="type_box">
            <div class="row_box">
                <p class="title_text">预测年数</p>
                <van-field v-model="formType.yearcount" maxlength="3" type="number" placeholder="请输入"><template #button><span>年</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">基准自由现金流<img @click="tipsClick('基准自由现金流', '自由现金流=税后利润+折旧-资本性支出<br>资本性支出：购建固定资产、无形资产和其他长期资产支付的现金')" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field v-model="formType.basecashmoney" type="number" placeholder="只输入第一年，后续年份自动计算"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">增长率</p>
                <van-field v-model="formType.insrate" placeholder="请输入"><template #button><span>%</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">折现率<img @click="tipsClick('折现率', '稳定性公司9%、周期性公12%、风险性公司15%')" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field v-model="formType.disrate" type="number" placeholder="请输入"><template #button><span>%</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">永续增长率<img @click="tipsClick('永续增长率', '可以采用国内生产总值增长率，即GDP的平均水平。')" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field v-model="formType.yxinsrate" placeholder="请输入"><template #button><span>%</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">验证码</p>
                <van-field v-model="usercode" maxlength="4" placeholder="请输入验证码"><template #button><img @click="getAuthCode" class="auth_code_img" :src="authCodeImg === '' ? require('@/common/images/gujingimgs/bg1.png') : authCodeImg" alt=""></template></van-field>
            </div>
        </div>
        <div v-if="typeValue === 'A04'" class="type_box">
            <div class="row_box">
                <p class="title_text">所处行业</p>
                <van-cell :title="formType.industryname === '' ? '请选择' : formType.industryname" is-link @click="selectIndustry"/>
            </div>
            <div class="row_box">
                <p class="title_text">单客收入</p>
                <van-field v-model="formType.incomebyper" type="number" placeholder="请输入"><template #button><span>元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">月活跃用户</p>
                <van-field v-model="formType.activeusercount" type="number" placeholder="请输入"><template #button><span>万</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">用户生命周期</p>
                <van-field v-model="formType.lifemonth" type="number" placeholder="请输入"><template #button><span>月</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">验证码</p>
                <van-field v-model="usercode" maxlength="4" placeholder="请输入验证码"><template #button><img @click="getAuthCode" class="auth_code_img" :src="authCodeImg === '' ? require('@/common/images/gujingimgs/bg1.png') : authCodeImg" alt=""></template></van-field>
            </div>
        </div>
        <div v-if="typeValue === 'A05'" class="type_box">
            <div class="row_box">
                <p class="title_text">团队评价</p>
                <van-field v-model="formType.teammoney" placeholder="请输入"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">产品前景评价</p>
                <van-field v-model="formType.productmoney" placeholder="请输入"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">盈利模式评价</p>
                <van-field v-model="formType.modemoney" placeholder="请输入"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">产品创意评价</p>
                <van-field v-model="formType.creativemoney" placeholder="请输入"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">董事会评价</p>
                <van-field v-model="formType.dshmoney" placeholder="请输入"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">验证码</p>
                <van-field v-model="usercode" maxlength="4" placeholder="请输入验证码"><template #button><img @click="getAuthCode" class="auth_code_img" :src="authCodeImg === '' ? require('@/common/images/gujingimgs/bg1.png') : authCodeImg" alt=""></template></van-field>
            </div>
        </div>
        <div v-if="typeValue === 'A06'" class="type_box">
            <div class="row_box">
                <p class="title_text">所处行业</p>
                <van-cell :title="formType.industryname === '' ? '请选择' : formType.industryname" is-link @click="selectIndustry"/>
            </div>
            <div class="row_box">
                <p class="title_text">上市成功后市盈率<img @click="tipsClick('基准自由现金流', '自由现金流=税后利润+折旧-资本性支出<br>资本性支出：购建固定资产、无形资产和其他长期资产支付的现金')" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field v-model="formType.pevalue" type="number" placeholder="根据行业默认，可以手动改"></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">净利润<img @click="tipsClick('折现率', '稳定性公司9%、周期性公12%、风险性公司15%')" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field v-model="formType.netprice" placeholder="请输入"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">投资者要求的年化回报率<img @click="tipsClick('永续增长率', '可以采用国内生产总值增长率，即GDP的平均水平。')" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field v-model="formType.yearrate" placeholder="请输入"><template #button><span>%</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">企业后续融资对股权的稀释比例<img @click="tipsClick('永续增长率', '可以采用国内生产总值增长率，即GDP的平均水平。')" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field v-model="formType.xsrate" type="number" placeholder="请输入"><template #button><span>%</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">预计上市年限</p>
                <van-field v-model="formType.ssyear" type="number" placeholder="请输入"><template #button><span>年</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">验证码</p>
                <van-field v-model="usercode" maxlength="4" placeholder="请输入验证码"><template #button><img @click="getAuthCode" class="auth_code_img" :src="authCodeImg === '' ? require('@/common/images/gujingimgs/bg1.png') : authCodeImg" alt=""></template></van-field>
            </div>
        </div>
    </div>
    <div class="btn_box">
        <div @click="upStep" class="up_btn">上一步</div>
        <div @click="startAppraisement" class="next_btn">开始估值</div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
        <van-picker
            show-toolbar
            :columns="industryData"
            @cancel="showPicker = false"
            @confirm="onConfirm"
        />
    </van-popup>
    <div class="tips_pop_warp">
        <van-popup v-model="showTipsPop">
            <div class="tips_box">
                <p class="p_title">{{tipsTitle}}</p>
                <p class="p_desc" v-html="tipsDesc"></p>
            </div>
        </van-popup>
    </div>
</div>
</template>

<script>
import {getIndustryinfoList, starEvOperation, createCode} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
import {Toast} from 'vant'
export default {
    name: 'MStepThree',
    data() {
        return {
            showTipsPop: false,
            tipsTitle: '',
            tipsDesc: '',
            typeValue: 'A01',
            showPicker: false,
            industryData: [],
            paramsValue: {
                evindustrytype: '',
                evphasetype: '',
                evuseagetype: ''
            },
            formType: {
                industrycode: '', //行业code
                industryname: '', //行业名称
                pevalue: '', //市盈率
                netprice: '', //净利润-单位万元
                pbvvalue: '', //市净率（P/BV）

                yearcount: '', //预测年数
                basecashmoney: '', //基准自由现金流-万元
                insrate: '', //增长率%
                disrate: 12, //折现率%（R)
                yxinsrate: '', //永续增长率%(g)

                industryk: '', //行业常数K
                incomebyper: '', //单客收入（元）
                activeusercount: '', //月活跃用户（万）
                lifemonth: '', //用户生命周期（月）

                teammoney: '', //团队评价（万元）
                productmoney: '', //产品前景评价（万元）
                modemoney: '', //盈利模式评价（万元）
                creativemoney: '', //产品创意评价（万元）
                dshmoney: '', //董事会评价（万元）

                yearrate: '', //年化回报率%
                xsrate: '', //稀释比例%
                ssyear: '' //预计上市年限（年）
            },
            usercode: '', // (用户输入的验证码)
            codeEncryption: '', // 加密后的验证码
            authCodeImg: '', // 验证码图片
            integer: /^[1-9]*[1-9][0-9]*$/, // 整数判断正则
            justfolter: /^([-1-9]\d{0,15}|0)(\.\d{1,2})?$/ // 小数判断正则
        }
    },
    mounted() {
        // this.findIndustryinfoList()
        // this.getAuthCode()
    },
    methods: {
        // 显示对应提示弹窗 及标题和内容
        tipsClick(tit, des) {
            this.tipsTitle = tit
            this.tipsDesc = des
            this.showTipsPop = true
        },
        // 获取验证码
        getAuthCode() {
            this.setLoading(true)
            let params = {}
            createCode({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.authCodeImg = data.result.base64
                    this.codeEncryption = data.result.codeEncryption
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 选择行业弹窗
        selectIndustry() {
            this.showPicker = true
        },
        onConfirm(value) {
            this.formType.industryname = value.text
            this.formType.industrycode = value.code
            if (this.typeValue === 'A01' || this.typeValue === 'A06') {
                this.formType.pevalue = value.lastdynsyl
            }
            if (this.typeValue === 'A02') {
                this.formType.pbvvalue = value.lastsjl
            }
            if (this.typeValue === 'A01' || this.typeValue === 'A02' || this.typeValue === 'A04' || this.typeValue === 'A06') {
                // console.log(value)
                this.formType.industryk = value.industryk
            }

            this.showPicker = false
            // console.log(value)
        },
        // 上一步
        upStep() {
            this.$emit('setStepValue', 1)
        },
        // 开始估值
        startAppraisement() {
            // console.log('this.paramsValue:', this.paramsValue)
            // console.log(this.formType)
            let regPos = /^\d+(\.\d+)?$/ //非负浮点数
            let regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ //负浮点数

            if (this.typeValue === 'A01' || this.typeValue === 'A02') {
                if (this.formType.industrycode === '') {
                    Toast('请选择所处行业')
                    return
                }
                if (this.typeValue === 'A01') {
                    if (this.formType.pevalue === '') {
                        Toast('请输入市盈率')
                        return
                    }
                    if (this.formType.pevalue < 0 || this.formType.pevalue > 1000 || !this.justfolter.test(this.formType.pevalue)) {
                        Toast('市盈率在0 - 1000之间, 且最多为两位小数')
                        return
                    }
                }
                if (this.typeValue === 'A02') {
                    if (this.formType.pbvvalue === '') {
                        Toast('请输入市净率')
                        return
                    }
                    if (this.formType.pbvvalue < 0 || this.formType.pbvvalue > 1000 || !this.justfolter.test(this.formType.pbvvalue)) {
                        Toast('市净率请在0 - 1000之间, 且最多为两位小数')
                        return
                    }
                }
                if (this.formType.netprice === '') {
                    if (this.typeValue === 'A01') {
                        Toast('请输入净利润')
                    } else {
                        Toast('请输入净资产')
                    }
                    return
                }
                if(regPos.test(this.formType.netprice) || regNeg.test(this.formType.netprice)){
                    if (this.formType.netprice < -10000000 || this.formType.netprice > 10000000) {
                        if (this.typeValue === 'A01') {
                            Toast('净利润在-10000000 - 10000000之间')
                        } else {
                            Toast('净资产在-10000000 - 10000000之间')
                        }
                        return
                    }
                }else{
                    if (this.typeValue === 'A01') {
                        Toast('净利润在-10000000 - 10000000之间')
                    } else {
                        Toast('净资产在-10000000 - 10000000之间')
                    }
                    return
                }
            }
            if (this.typeValue === 'A03') {
                if (this.formType.yearcount === '') {
                    Toast('请输入预测年数')
                    return
                }
                if (!this.integer.test(this.formType.yearcount)) {
                    Toast('预测年数为非0整数')
                    return
                }
                if (this.formType.yearcount < 1 || this.formType.yearcount > 100) {
                    Toast('预测年数在1 - 100之间')
                    return
                }
                if (this.formType.basecashmoney === '') {
                    Toast('请输入基准自由现金流')
                    return
                }
                if (this.formType.basecashmoney < 0 || this.formType.basecashmoney > 10000000) {
                    Toast('基准自由现金流请在0 - 10000000之间')
                    return
                }
                if (this.formType.insrate === '') {
                    Toast('请输入增长率')
                    return
                }
                if(regPos.test(this.formType.insrate) || regNeg.test(this.formType.insrate)){
                    if (this.formType.insrate < -1000 || this.formType.insrate > 1000 || !(this.justfolter.test(this.formType.insrate))) {
                        Toast('增长率在-1000 - 1000之间，且最多为两位小数')
                        return
                    }
                }else{
                    Toast('增长率在-1000 - 1000之间，且最多为两位小数')
                    return
                }
                if (this.formType.disrate === '') {
                    Toast('请输入折现率')
                    return
                }
                if (this.formType.disrate < 0 || this.formType.disrate > 24 || !(this.justfolter.test(this.formType.disrate))) {
                    Toast('折现率在0 - 24之间，且最多两位小数')
                    return
                }
                if (this.formType.yxinsrate === '') {
                    Toast('请输入永续增长率')
                    return
                }
                if(regPos.test(this.formType.yxinsrate) || regNeg.test(this.formType.yxinsrate)){
                    if (this.formType.yxinsrate < -100 || this.formType.yxinsrate > 100 || !(this.justfolter.test(this.formType.yxinsrate))) {
                        Toast('永续增长率在-100 - 100之间，且最多两位小数')
                        return
                    }
                }else{
                    Toast('永续增长率在-100 - 100之间，且最多两位小数')
                    return
                }
                if (this.formType.disrate == this.formType.yxinsrate){
                    Toast('折现率和永续增长率不能相等')
                    return
                }
            }
            if (this.typeValue === 'A04') {
                if (this.formType.industrycode === '') {
                    Toast('请选择所处行业')
                    return
                }
                if (this.formType.incomebyper === '') {
                    Toast('请输入单客收入')
                    return
                }
                if (this.formType.incomebyper < 0 || this.formType.incomebyper > 100000000) {
                    Toast('单客收入在0 - 100000000之间')
                    return
                }
                if (this.formType.activeusercount === '') {
                    Toast('请输入月活跃用户')
                    return
                }
                if (this.formType.activeusercount < 0 || this.formType.activeusercount > 1000000) {
                    Toast('月活跃用户在0 - 1000000之间')
                    return
                }
                if (this.formType.lifemonth === '') {
                    Toast('请输入用户生命周期')
                    return
                }
                if (!this.integer.test(this.formType.lifemonth)) {
                    Toast('用户生命周期请为非0整数')
                    return
                }
                if (this.formType.lifemonth < 0 || this.formType.lifemonth > 1000) {
                    Toast('用户生命周期请在1 - 1000')
                    return
                }
            }
            if (this.typeValue === 'A05') {
                if (this.formType.teammoney === '') {
                    Toast('请输入团队评价')
                    return
                }
                if(regPos.test(this.formType.teammoney) || regNeg.test(this.formType.teammoney)){
                    if (this.formType.teammoney < -1000000 || this.formType.teammoney > 1000000 || !(this.justfolter.test(this.formType.teammoney))) {
                        Toast('团队评价在-1000000 - 1000000之间，且最多两位小数')
                        return
                    }
                }else{
                    Toast('团队评价在-1000000 - 1000000之间，且最多两位小数')
                    return
                }
                if (this.formType.productmoney === '') {
                    Toast('请输入产品前景评价')
                    return
                }
                if(regPos.test(this.formType.productmoney) || regNeg.test(this.formType.productmoney)){
                    if (this.formType.productmoney < -1000000 || this.formType.productmoney > 1000000 || !(this.justfolter.test(this.formType.productmoney))) {
                        Toast('产品前景评价在-1000000 - 1000000之间，且最多两位小数')
                        return
                    }
                }else{
                    Toast('产品前景评价在-1000000 - 1000000之间，且最多两位小数')
                    return
                }
                if (this.formType.modemoney === '') {
                    Toast('请输入盈利模式评价')
                    return
                }
                if(regPos.test(this.formType.modemoney) || regNeg.test(this.formType.modemoney)){
                    if (this.formType.modemoney < -1000000 || this.formType.modemoney > 1000000 || !(this.justfolter.test(this.formType.modemoney))) {
                        Toast('盈利模式评价在-1000000 - 1000000之间，且最多两位小数')
                        return
                    }
                }else{
                    Toast('盈利模式评价在-1000000 - 1000000之间，且最多两位小数')
                    return
                }
                if (this.formType.creativemoney === '') {
                    Toast('请输入产品创意评价')
                    return
                }
                if(regPos.test(this.formType.creativemoney) || regNeg.test(this.formType.creativemoney)){
                    if (this.formType.creativemoney < -1000000 || this.formType.creativemoney > 1000000 || !(this.justfolter.test(this.formType.creativemoney))) {
                        Toast('产品创意评价在-1000000 - 1000000之间，且最多两位小数')
                        return
                    }
                }else{
                    Toast('产品创意评价在-1000000 - 1000000之间，且最多两位小数')
                    return
                }
                if (this.formType.dshmoney === '') {
                    Toast('请输入董事会评价')
                    return
                }
                if(regPos.test(this.formType.dshmoney) || regNeg.test(this.formType.dshmoney)){
                    if (this.formType.dshmoney < -1000000 || this.formType.dshmoney > 1000000 || !(this.justfolter.test(this.formType.dshmoney))) {
                        Toast('董事会评价在-1000000 - 1000000之间，且最多两位小数')
                        return
                    }
                }else{
                    Toast('董事会评价在-1000000 - 1000000之间，且最多两位小数')
                    return
                }
            }
            if (this.typeValue === 'A06') {
                if (this.formType.industrycode === '') {
                    Toast('请选择所处行业')
                    return
                }
                if (this.formType.pevalue === '') {
                    Toast('请输入上市成功后市盈率')
                    return
                }
                if (this.formType.netprice === '') {
                    Toast('请输入净利润')
                    return
                }
                if(regPos.test(this.formType.netprice) || regNeg.test(this.formType.netprice)){
                    if (this.formType.netprice < -1000000 || this.formType.netprice > 1000000 || !(this.justfolter.test(this.formType.netprice))) {
                        Toast('净利润在-1000000 - 1000000之间，且最多两位小数')
                        return
                    }
                }else{
                    Toast('净利润在-1000000 - 1000000之间，且最多两位小数')
                    return
                }
                if (this.formType.yearrate === '') {
                    Toast('请输入投资者要求的年化回报率')
                    return
                }
                if(regPos.test(this.formType.yearrate) || regNeg.test(this.formType.yearrate)){
                    if (this.formType.yearrate < -100 || this.formType.yearrate > 100 || !(this.justfolter.test(this.formType.yearrate))) {
                        Toast('投资者要求的年化回报率在-100 - 100之间，且最多两位小数')
                        return
                    }
                }else{
                    Toast('投资者要求的年化回报率在-100 - 100之间，且最多两位小数')
                    return
                }
                if (this.formType.xsrate === '') {
                    Toast('请输入企业后续融资对股权的稀释比例')
                    return
                }
                if (this.formType.xsrate < 0 || this.formType.xsrate > 100 || !(this.justfolter.test(this.formType.xsrate))) {
                    Toast('企业后续融资对股权的稀释比例在0 - 100之间，且最多两位小数')
                    return
                }
                if (this.formType.ssyear === '') {
                    Toast('请输入预计上市年限')
                    return
                }
                if (!(this.integer.test(this.formType.ssyear))) {
                    Toast('预计上市年限为非0整数')
                    return
                }
                if (this.formType.ssyear < 1 || this.formType.ssyear > 100) {
                    Toast('预计上市年限在1 - 100之间')
                    return
                }
            }
            if (this.usercode.length == 0) {
                Toast('请输入验证码')
                return
            }
            // Toast('开始估值')
            this.starEvOperationFn()
        },
        starEvOperationFn() {
            this.setLoading(true)
            let params = {
                code: this.typeValue,
                usercode: this.usercode,
                codeEncryption: this.codeEncryption,
                importinfo: JSON.stringify(this.formType)
            }
            starEvOperation({
                data: Object.assign({}, params, this.paramsValue),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    if (data) {
                        this.$emit('setStepValue', 3)
                        this.$emit('setResultData', data.data)
                    }
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 设置估值需要的行业参数
        setParamsValue(val) {
            this.paramsValue = val
            // console.log('this.paramsValue:', this.paramsValue)
        },
        // 获取行业列表
        findIndustryinfoList() {
            this.setLoading(true)
            let params = {}
            getIndustryinfoList({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.industryData = data.data.content
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 设置估值要素的表单类型
        getTypeValue(val) {
            this.typeValue = val
            // console.log(this.typeValue)
            this.findIndustryinfoList()
            this.getAuthCode()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.MStepThree {
    padding-bottom: 0.8rem;
    .content_warp {
        background-color: #fff;
        padding: 0.32rem;
        padding-top: 0.02rem;
        .type_box {
            .row_box {
                border-bottom: 0.01rem solid #E5E5E5;
                padding-top: 0.3rem;
                padding-bottom: 0.12rem;
                .title_text {
                    color: #333;
                    font-size: 0.32rem;
                    line-height: 0.46rem;
                    padding-bottom: 0.08rem;
                    display: flex;
                    align-items: center;
                    &>img {
                        margin-left: 0.2rem;
                        width: 0.22rem;
                        height: 0.22rem;
                    }
                }
                .van-cell{
                    padding: 0.2rem 0;
                    font-size: 0.32rem;
                }
                .auth_code_img {
                    width: 1.6rem;
                    height: 0.68rem;
                }
            }
            .row_box:nth-last-of-type(1){
                border-bottom: none;
                padding-bottom: 0;
                .van-cell{
                    padding-bottom: 0;
                }
            }
        }
    }
    .btn_box {
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        width: 100vw;
        &>div {
            width: 50vw;
            height: 0.8rem;
            line-height: 0.8rem;
            text-align: center;
            font-size: 0.32rem;
            background-color: #E5E5E5;
            color: #666;
        }
        .next_btn {
            background-color: #409EFF;
            color: #fff;
        }
    }
    .tips_pop_warp {
        .van-popup{
            width: 5.6rem;
            border-radius: 0.1rem;
        }
        .tips_box {
            border-radius: 0.5rem;
            padding: 0.4rem 0.22rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            .p_title {
                margin-bottom: 0.32rem;
                font-size: 0.36rem;
                line-height: 0.5rem;
                text-align: center;
            }
            .p_desc {
                padding: 0 0.18rem;
                font-size: 0.32rem;
                line-height: 0.54rem;
                color: #666;
            }
        }
    }
}
</style>